import React, { useState, useEffect } from "react";
import { TarifForm } from "./TarifForm";
import { Card, Col, message, Row } from "antd";
import { TarifTable } from "./TarifTable";
import axios from "axios";
import { API_URL } from "../../../constants";
import { useSelector } from "react-redux";

const TarifManager = () => {
  const [editTarif, setEditTarif] = useState(null);
  const accessToken = useSelector(
    (state) => state.user.currentUser?.accessToken
  );
  const [tarifs, setTarifs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [messageApi, contextHolder] = message.useMessage();
  const getTarifs = async () => {
    try {
      const res = await axios.get(API_URL + "user/tarif", {
        headers: { Authorization: "Bearer " + accessToken },
      });

      setTarifs(res.data);
      setLoading(false);
    } catch (error) {
      console.log({ error });
      setLoading(false);
    }
  };
  const onCreate = async (values) => {
    try {
      const res = await axios.post(API_URL + "user/tarif", values, {
        headers: { Authorization: "Bearer " + accessToken },
      });
      console.log({ res: res.data });
      if (res.data) {
        messageApi.success("Tariful a fost creat cu succes!");
        getTarifs();
        setEditTarif(null);
      }
    } catch (error) {
      console.log(error);
      if (
        error?.response?.data?.meta?.target === "Tarif_SERVICEID_startDate_key"
      ) {
        messageApi.error(
          "Tariful pentru acest serviciu cu data de începere indicată deja există."
        );
      }
    }
  };
  const onUpdate = async (values) => {
    try {
      const res = await axios.patch(API_URL + "user/tarif", values, {
        headers: { Authorization: "Bearer " + accessToken },
      });
      console.log({ res: res.data });
      if (res.data) {
        messageApi.success("Tariful a fost actualizat cu succes!");
        getTarifs();
        setEditTarif(null);
      }
    } catch (error) {
      console.log(error);
      if (
        error?.response?.data?.meta?.target === "Tarif_SERVICEID_startDate_key"
      ) {
        messageApi.error(
          "Tariful pentru acest serviciu cu data de începere indicată deja există."
        );
      }
    }
  };

  const onEditTarif = (id) => {
    setEditTarif(tarifs.find((tarif) => tarif.id === id));
  };

  useEffect(() => {
    getTarifs();
  }, []);

  return (
    <Row gutter={24}>
      {contextHolder}
      <Col xs={8}>
        <Card title={"Stabilirea tarifului"} loading={loading}>
          <TarifForm
            onCreate={onCreate}
            onUpdate={onUpdate}
            initialValues={editTarif}
            onCancel={() => setEditTarif(null)}
          />
        </Card>
      </Col>
      <Col xs={16}>
        <Card loading={loading}>
          <TarifTable tarifs={tarifs} setEditTarif={onEditTarif} />
        </Card>
      </Col>
    </Row>
  );
};

export default TarifManager;
